import { render, staticRenderFns } from "./MonitorDashboardIndex.vue?vue&type=template&id=2a9e8f6c&scoped=true&"
import script from "./MonitorDashboardIndex.vue?vue&type=script&lang=ts&"
export * from "./MonitorDashboardIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9e8f6c",
  null
  
)

export default component.exports